import React, { useState } from "react";
import { generateColor, getRandomColor, getpast } from "../function";
import MainColor from "./MainColor";
import ChooseColor from "./ChooseColor/ChooseColor";
import "./scoreBoard.css";
const properties = {
  qc: 10,
  po: 5,
  ne: 2,
};
export default (props) => {
  const [score, changeScore] = useState({
    right: 0,
    wrong: 0,
  });
  const [scoreBoard, updateScoreBoard] = useState(Array());
  const [questionNumber, nextQuestion] = useState(0);
  const [color, changeColor] = useState([
    getRandomColor(),
    getRandomColor(),
    getRandomColor(),
    getRandomColor(),
    Math.floor(Math.random() * 3),
  ]);
  const [pastScore, pastScoreChange] = useState(getpast());
  if (questionNumber === properties.qc) {
    /*alert(
      `Score : ${5 * score.right - 2 * score.wrong}\nright : ${
        score.right
      }\nwrong : ${score.wrong}`
    );*/
    pastScoreChange([
      ...pastScore,
      {
        date: new Date(),
        ...score,
        score: properties.po * score.right - properties.ne * score.wrong,
      },
    ]);
    updateScoreBoard(Array());
    nextQuestion(0);
    changeScore({
      right: 0,
      wrong: 0,
    });
    localStorage.setItem(
      "allScore",
      JSON.stringify([
        ...pastScore,
        {
          date: new Date(),
          ...score,
          score: properties.po * score.right - properties.ne * score.wrong,
        },
      ])
    );
  }
  const colorClick = (sc) => {
    if (sc === color[color[4]]) {
      changeScore({ ...score, right: score.right + 1 });
      scoreBoard[scoreBoard.length] = 1;
    } else {
      changeScore({ ...score, wrong: score.wrong + 1 });
      scoreBoard[scoreBoard.length] = 0;
    }
    changeColor([
      getRandomColor(),
      getRandomColor(),
      getRandomColor(),
      getRandomColor(),
      Math.floor(Math.random() * 3),
    ]);
    nextQuestion(questionNumber + 1);
  };
  return (
    <>
      <div className="main-screen">
        <span className="score-board">
          {scoreBoard.length === 0 ? 0 : ""}
          {scoreBoard.map((score) => {
            if (score === 1) {
              return (
                <span className="score-board-positive">+{properties.po}</span>
              );
            } else {
              return (
                <span className="score-board-negative">-{properties.ne}</span>
              );
            }
          })}
        </span>
        <MainColor
          color={color}
          questionNumber={questionNumber}
          generateColor={generateColor}
        />
        <hr className="hr" />
        <ChooseColor color={color} colorClick={colorClick} />
      </div>
    </>
  );
};
